import PreviewImageInsertUI from "./PreviewImageInsertUI";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class PreviewImageInsert extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "PreviewImageInsert";
  }

  static get requires() {
    return [PreviewImageInsertUI];
  }
}
